<template>
  <div class="container">
    <div
      class="row mb-3"
      v-if="!isAddOrEdit"
    >
      <div
        class="col-1"
        @click="$router.push('/sites')"
      >
        <i class="fa fa-arrow-left fa-2x"></i>
      </div>
    </div>
    <div
      class="row mb-3"
      v-if="isAddOrEdit"
    >
      <div
        class="col-1"
        @click="setIsAddOrEdit(false)"
      >
        <i class="fa fa-arrow-left fa-2x"></i>
      </div>
    </div>
    <div
      class="row"
      v-if="isAddOrEdit"
    >
      <div class="col">
        <div class="card">
          <form @submit.prevent="saveUrl($route.params.id)">
            <div class="card-header">
              <h3 v-if="url.id">{{ $t("gpool.edit_url") }}: {{ url.url }}</h3>
              <h3 v-else>{{ $t("gpool.add_url") }}</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <label
                    class="form-label"
                    for="url"
                    >{{ $t("gpool.form_path") }}</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    required
                    :readonly="posting"
                    :disabled="posting"
                    v-model="url.url"
                  />
                </div>
                <div class="col">
                  <label
                    class="form-label"
                    for="request_method"
                    >{{ $t("gpool.form_request_method") }}</label
                  >
                  <select
                    name="request_method"
                    id="request_method"
                    class="form-control"
                    required
                    :readonly="posting"
                    :disabled="posting"
                    v-model="url.request_method"
                  >
                    <option
                      value=""
                      selected
                      disabled
                    >
                      {{ $t("gpool.form_select_request_method") }}
                    </option>
                    <option
                      v-for="method in [
                        'GET',
                        'POST',
                        'PUT',
                        'PATCH',
                        'DELETE'
                      ]"
                      :key="method"
                      :value="method"
                      :selected="method === url.request_method"
                    >
                      {{ method }}
                    </option>
                  </select>
                </div>
                <div class="col">
                  <label
                    class="form-label"
                    for="request_type"
                    >{{ $t("gpool.form_request_type") }}</label
                  >
                  <select
                    name="request_type"
                    id="request_type"
                    class="form-control"
                    required
                    :readonly="posting"
                    :disabled="posting"
                    v-model="url.request_type"
                  >
                    <option
                      value=""
                      selected
                      disabled
                    >
                      {{ $t("gpool.form_select_request_type") }}
                    </option>
                    <option
                      v-for="req_type in [
                        'STATUS',
                        'PING',
                        'AUTH',
                        'CREDIT',
                        'BALANCE'
                      ]"
                      :key="req_type"
                      :value="req_type"
                      :selected="req_type === url.request_type"
                    >
                      {{ req_type }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                :disabled="posting"
                type="submit"
                class="btn"
                :class="{
                  'btn-success': !url.id,
                  'btn-primary': url.id
                }"
              >
                <i
                  v-if="posting"
                  class="fa fa-spinner fa-spin"
                ></i>
                <template v-else>
                  <span v-if="url.id">
                    {{ $t("gpool.form_update") }}
                  </span>
                  <span v-else>
                    {{ $t("gpool.form_add") }}
                  </span>
                </template>
              </button>
              <button
                class="btn btn-link"
                @click="setIsAddOrEdit(false)"
              >
                {{ $t("gpool.form_cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-else
    >
      <div class="col">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <h3>{{ $t("gpool.urls") }}</h3>
              </div>
              <div class="col text-end">
                <button
                  class="btn btn-primary"
                  @click="setIsAddOrEdit(true)"
                >
                  <i class="fa fa-plus"></i>
                  <span class="ms-2 align-middle">
                    {{ $t("gpool.add_url") }}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              class="rounded-0 position-absolute w-100 progress"
              style="height: 6px"
              v-if="loading"
            >
              <div
                role="progressbar"
                class="progress-bar progress-bar-animated progress-bar-striped"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
                style="width: 100%"
              ></div>
            </div>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>{{ $t("gpool.table_path") }}</th>
                  <th>
                    {{ $t("gpool.table_request_method") }}
                  </th>
                  <th>
                    {{ $t("gpool.table_request_type") }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="url in urls"
                  :key="url.id"
                >
                  <td>{{ url.id }}</td>
                  <td>{{ url.url }}</td>
                  <td>{{ url.request_method }}</td>
                  <td>{{ url.request_type }}</td>
                  <td>
                    <div
                      role="group"
                      class="btn-group"
                    >
                      <button
                        type="button"
                        class="btn"
                        @click="editUrl(url.id)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        @click="
                          deleteUrl({
                            site_id: $route.params.id,
                            url_id: url.id
                          })
                        "
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Urls",
  computed: {
    ...mapGetters("urls", ["urls", "url", "posting", "isAddOrEdit", "loading"])
  },
  beforeDestroy() {
    this.resetUrls();
  },
  mounted() {
    this.getUrls(this.$route.params.id);
  },
  methods: {
    ...mapMutations("urls", ["setIsAddOrEdit", "resetUrls"]),
    ...mapActions("urls", ["getUrls", "saveUrl", "editUrl", "deleteUrl"])
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Urls.vue